var domainUrl = document.getElementById("site-url").innerText;

window.onload = function() {
    domainUrl = document.getElementById("site-url").innerText;
    if (window.jQuery) {
        console.log("jquery present");
    } else {
            console.log("adding jquery");
            var jquery_script = document.createElement("script"); 
            jquery_script.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js";  
            document.getElementsByTagName('head')[0].appendChild(jquery_script);        
    }
    var shopify_script = document.createElement("script"); 
    shopify_script.src = "https://cdn.shopify.com/s/shopify/api.jquery.js";
    document.getElementsByTagName('head')[0].appendChild(shopify_script);
}

// Setting count for add all to cart products
var addToCartCount;
var product_sections;

// ADD ALL TO CART LINK
var addBasicsToCartLink;
var addEssentialToCartLink;
var addWorksToCartLink;
var addAdditionalToCartLink;

var active_basics_count = 0;
var active_essential_count = 0;
var active_works_count = 0;
var active_additional_count = 0;

var basics_array =[];
var essential_array =[];
var works_array =[];
var additional_array =[];

var active_product_count = 0;

var url_string = window.location.href;
var url = new URL(url_string);

// ALL PRODUCTS LIST
var products;

let selected_pdt;
var imgid = url.searchParams.get("id");
var resp_id = url.searchParams.get("resp_id");

var language_isocode = document.getElementById("site-iso-code").innerText;
var default_addToCartText = "Add to cart";
var default_addedToCartText = "Added to Cart!";
let outOfStock = "Out of Stock";
var domainCurrency;

// Default url path for product
var variant_product_url;

var product_options_map = {};

var option1array = [];
var option2array = [];
var option3array = [];

var variantOption1_div;
var variantOption2_div;
var variantOption3_div;

// Options name mapped to variant id
var option2_variant_map = {};

var skip_selfie=false;

// ALL TAGS
var all_tags;

if (resp_id != null) {

    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id=" + resp_id + "&self_serve=true" + "&multiple_variants=true";
    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
            if (xmlhttp.status == 200) {
                var jsonData = JSON.parse(xmlhttp.responseText);
                products = jsonData.products;
              
                domainCurrency = document.getElementById("site-currency").innerText; 
                all_tags = jsonData.tags;

                // Setting active tab using tags
                setActiveTab();

                product_sections = jsonData.product_sections;
                if(product_sections!=undefined){
                  createProductSection(jsonData);
                }
                
                if(jsonData.text_sections!=undefined){
                  createTextSection(jsonData);
                }
                
                addBasicsToCartLink = domainUrl + "/cart/add?id[]=";
                addEssentialToCartLink = domainUrl + "/cart/add?id[]=";
                addWorksToCartLink = domainUrl + "/cart/add?id[]=";
                addAdditionalToCartLink = domainUrl + "/cart/add?id[]=";

                if (products.length > 0) {
                    selected_pdt = {};
                    active_product_count = 0;
                    var select_variant_obj;
                    for (var p = 0; p < products.length; p++) {
                        select_variant_obj = products[p].variants[0];
                        option1array = [];
                        option2array = [];
                        option3array = [];
                        variant_product_url = domainUrl + '/products/';
                        var variant_price;

                        var imgsrc = "";
                        if (domainCurrency == "") {
                            domainCurrency = '$';
                        }
                        if (products[p].images != undefined) {
                            imgsrc = getVariantImage(products[p].variants[0].image_id,products[p]);
                        }
                        else{
                            imgsrc = "https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp";
                        }

                        variantOption1_div = document.createElement("div");
                        variantOption1_div.classList.add("tangent_option_div");

                        variantOption2_div = document.createElement("div");
                        variantOption2_div.classList.add("tangent_option_div");

                        variantOption3_div = document.createElement("div");
                        variantOption3_div.classList.add("tangent_option_div");

                        var variant_checkbox_elm = document.getElementById('tangent_variant_view_check');

                        variant_price = products[p].variants[0].price;
                        variant_product_url = variant_product_url + products[p].handle + "?variant=" + products[p].variants[0].id;

                        let selectedVariant = isSelectedVariantPresent(jsonData.selected_variants, products[p].id)

                        // CHECK FOR VARIANT ENABLED
                        if (!selectedVariant.length && products[p].variants.length > 1) {
                            if (variant_checkbox_elm != undefined && variant_checkbox_elm != null) {
                                if (variant_checkbox_elm.value==true || variant_checkbox_elm.value=="true") {

                                    var variants_div = document.createElement("div");
                                    variants_div.id = 'tangent_checkout_variants_div_' + p;
                                    variants_div.classList.add("tangent_checkout_variants_div");
                                    variants_div.style.display = "none";

                                    var variantsub_div = document.createElement("div");
                                    variants_div.appendChild(variantsub_div);
                                    var _variants = products[p].variants;
                                    var option1_ele_arr = [];
                                    var option2_ele_arr = [];
                                    var option3_ele_arr = [];

                                    var option_obj = {};

                                    variants_div.style.display = "block";

                                    // Product Option 1 Name Element
                                    var option1_name = document.createElement("p");
                                    option1_name.id = "optionName_variant:product_" + p;
                                    option1_name.innerText = products[p].options[0].name + ":";
                                    option1_name.classList.add("tangent_option_name");
                                    variantOption1_div.append(option1_name);

                                    // Creating values for product option 1 
                                    var option1_values = products[p].options[0].values;
                                    for (var opt1v = 0; opt1v < option1_values.length; opt1v++) {
                                        var variants_option1 = document.createElement("p");
                                        variants_option1.id = "product_" + p + ":option_" + opt1v;
                                        variants_option1.title = option1_values[opt1v];
                                        variants_option1.innerText = option1_values[opt1v];
                                        variants_option1.classList.add("tangent_option");
                                        variants_option1.classList.add("product_" + p + "v1");
                                        variants_option1.classList.add("tangent_options_1");

                                        if (!option1array.includes(option1_values[opt1v])) {
                                            option1array.push(option1_values[opt1v]);
                                            option1_ele_arr.push(variants_option1);
                                            variantOption1_div.appendChild(variants_option1);
                                        }
                                    }
                                    if (option1_ele_arr.length > 0) { option_obj["option1"] = option1_ele_arr; }

                                    // Product Option 2 Name Element
                                    if (products[p].options.length > 1) {
                                        var option2_name = document.createElement("p");
                                        option2_name.id = "optionName_variant:product_" + p;
                                        option2_name.innerText = products[p].options[1].name + ":";
                                        option2_name.classList.add("tangent_option_name");
                                        variantOption2_div.append(option2_name);
                                    }

                                    // Creating values for product option 2
                                    if (products[p].options[1] != undefined) {
                                        var option2_values = products[p].options[1].values;
                                        for (var opt2v = 0; opt2v < option2_values.length; opt2v++) {
                                            var variants_option2 = document.createElement("p");
                                            variants_option2.id = "product_" + p + ":option_" + opt2v;
                                            variants_option2.title = option2_values[opt2v];
                                            variants_option2.innerText = option2_values[opt2v];
                                            variants_option2.classList.add("tangent_option");
                                            variants_option2.classList.add("product_" + p + "v2");
                                            variants_option2.classList.add("tangent_options_2");

                                            if (!option2array.includes(option2_values[opt2v])) {
                                                option2array.push(option2_values[opt2v]);
                                                option2_ele_arr.push(variants_option2);
                                                variantOption2_div.appendChild(variants_option2);
                                            }
                                        }
                                    }
                                    if (option2_ele_arr.length) { option_obj["option2"] = option2_ele_arr; }

                                    // Product Option 3 Name Element
                                    if (products[p].options.length > 2) {
                                        var option3_name = document.createElement("p");
                                        option3_name.id = "optionName_variant:product_" + p;
                                        option3_name.innerText = products[p].options[2].name + ":";
                                        option3_name.classList.add("tangent_option_name");
                                        variantOption3_div.append(option3_name);
                                    }

                                    // Creating values for product option 3
                                    if (products[p].options[2] != undefined) {
                                        var option3_values = products[p].options[2].values;
                                        for (var opt3v = 0; opt3v < option3_values.length; opt3v++) {
                                            var variants_option3 = document.createElement("p");
                                            variants_option3.id = "product_" + p + ":option_" + opt3v;
                                            variants_option3.title = option3_values[opt3v];
                                            variants_option3.innerText = option3_values[opt3v];
                                            variants_option3.classList.add("tangent_option");
                                            variants_option3.classList.add("product_" + p + "v3");
                                            variants_option3.classList.add("tangent_options_3");

                                            if (!option3array.includes(option3_values[opt3v])) {
                                                option3array.push(option3_values[opt3v]);
                                                option3_ele_arr.push(variants_option3);
                                                variantOption3_div.appendChild(variants_option3);
                                            }
                                        }
                                    }
                                    if (option3_ele_arr.length > 0) { option_obj["option3"] = option3_ele_arr; }

                                    product_options_map[products[p].id] = option_obj;

                                    var option2_var = {};
                                    var selected_variant;

                                    // All options for the product
                                    var options1;
                                    var options2;
                                    var options3;

                                    for (var v = 0; v < _variants.length; v++) {

                                        var optVariant;
                                        if (_variants[v].option1 != null) {
                                            optVariant = _variants[v].option1
                                        }
                                        if (_variants[v].option2 != null) {
                                            optVariant = optVariant + "_" + _variants[v].option2
                                        }
                                        if (_variants[v].option3 != null) {
                                            optVariant = optVariant + "_" + _variants[v].option3
                                        }

                                        option2_var[optVariant] = _variants[v];
                                        option2_variant_map[products[p].id] = option2_var;
                                    }

                                    // When product has no variant previously selected
                                    // Default Select Option 1
                                    if (product_options_map[products[p].id].option1 != undefined) {
                                        if (product_options_map[products[p].id].option1.length > 0) {
                                            options1 = product_options_map[products[p].id].option1;
                                            options1[0].classList.add("tangent_selected-variant");
                                        }
                                    }

                                    // Default Select Option 2
                                    if (product_options_map[products[p].id].option2 != undefined) {
                                        if (product_options_map[products[p].id].option2.length > 0) {
                                            options2 = product_options_map[products[p].id].option2;
                                            options2[0].classList.add("tangent_selected-variant");
                                        }
                                    }

                                    // Default Select Option 3
                                    if (product_options_map[products[p].id].option3 != undefined) {
                                        if (product_options_map[products[p].id].option3.length > 0) {
                                            options3 = product_options_map[products[p].id].option3;
                                            options3[0].classList.add("tangent_selected-variant");
                                        }
                                    }

                                    selected_pdt[products[p].id] = _variants[0].id + "";
                                    select_variant_obj = _variants[0];

                                    variant_price = _variants[0].price;
                                    variant_product_url = variant_product_url + products[p].handle + "?variant=" + _variants[0].id;

                                    variantsub_div.appendChild(variantOption1_div);
                                    variantsub_div.appendChild(variantOption2_div);
                                    variantsub_div.appendChild(variantOption3_div);

                                }
                            }
                        }
                        if (selected_pdt[products[p].id] == null) {
                            selected_pdt[products[p].id] = products[p].variants[0].id;
                        }
                        if (!selectedVariant.length && (products[p].variants.length > 1 || products[p].variants.length == 1)) {
                            var product_html;
                            if(domainUrl==undefined){
                                domainUrl = document.getElementById("site-url").innerText;
                            }
                        
                            var pdtPrice = products[p].variants[0].price;
                            var var_products = products[p].variants;
                            var var_images = products[p].images;
                            var p_id = products[p].id;
                            var added_pdt = false;
                            if(product_sections!=undefined){
                              for (const section in product_sections) {
                                if (product_sections[section].includes(String(products[p].id))) {
                                  
                                  let product_available = isProductAvailable(products[p], select_variant_obj);
                                  if(product_available){
                                    var product_section_grid = document.getElementById(section+"_product_grid");
                                    addToCartID = var_products[0].id;
                                    var image_id = var_products[0].image_id;
                                    for(var im=0;im<var_images.length;im++){
                                      if(image_id==var_images[im].id){
                                        imgsrc = var_images[im].src;
                                      }
                                    }
  
                                    
                                    product_html = '<div><a id="url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="image_tangent_product_' + p + '" src="' + imgsrc + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p id="price_tangent_product_' + p + '" class="tangent_product_price_text">' + domainCurrency + pdtPrice + '</p></a><div id='+section+'_variant_'+p+'></div><a class="tangent-product-add-btn-wrapper" id="'+selected_pdt[products[p].id]+'" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="'+section+'_cart_tangent_product_' + p + '_text">' + default_addToCartText + '</p></a><div/>';
                                    product_section_grid.innerHTML = product_section_grid.innerHTML + product_html;
  
                                    // ADDING VARIANT SECTION
                                    var variant_section = document.getElementById(section+'_variant_'+p);
                                    
                                    if(variant_section!=undefined){
                                      if(products[p].variants.length > 1){
                                        if (variant_checkbox_elm != undefined && variant_checkbox_elm != null) {
                                          if (variant_checkbox_elm.value==true || variant_checkbox_elm.value=="true") {
                                            const clone = variants_div.cloneNode(true);
                                            var options1 = clone.getElementsByClassName("tangent_options_1");
                                            var options2 = clone.getElementsByClassName("tangent_options_2");
                                            var options3 = clone.getElementsByClassName("tangent_options_3");
                                            if(options1.length>0){
                                              for(var opt1=0;opt1<options1.length;opt1++){
                                                var tempId = section+"_"+options1[opt1].id;
                                                options1[opt1].id = tempId;
                                                options1[opt1].classList.add(section+"_product_"+p);
                                              }
                                            }
                                            if(options2.length>0){
                                              for(var opt2=0;opt2<options2.length;opt2++){
                                                var tempId = section+"_"+options2[opt2].id;
                                                options2[opt2].id = tempId;
                                                options2[opt2].classList.add(section+"_product_"+p);
                                              }
                                            }
                                            if(options3.length>0){
                                              for(var opt3=0;opt3<options3.length;opt3++){
                                                var tempId = section+"_"+options3[opt3].id;
                                                options3[opt3].id = tempId;
                                                options3[opt3].classList.add(section+"_product_"+p);
                                              }
                                            }
                                            variant_section.appendChild(clone);
                                          }
                                        }
                                      }
                                    }
                                    
                                    var cart_btn = document.getElementById(section+'_cart_tangent_product_' + p + '_text');
                                    if(cart_btn!=undefined){
                                      addToCartLink(products[p].id,selected_pdt[products[p].id]);
                                    } 
                                  }
                                }                                
                              }
                            }
                        }
                      
                        //displaying selected products
                        if (selectedVariant.length) {
                            for (let i = 0; i < selectedVariant.length; i++) {
                                products[p].variants.forEach((variant) => {
                                    if (selectedVariant[i] == variant.id) {
                                        let imgurl = getVariantImage(variant.image_id,products[p]);
                                        let product_url = domainUrl + "/products/" + products[p].handle + "?variant=" + variant.id;
                                        
                                        let addTocartClass; 
                                        let buttonText;

                                        if(variant.inventory_policy == "deny"){
                                            if(variant.inventory_quantity<1){
                                              if(variant.inventory_management!=null){
                                                addTocartClass = "disable-btn-wrapper";
                                                buttonText = outOfStock;
                                              }  
                                              else{
                                                buttonText = default_addToCartText;
                                                addToCartLink(products[p].id,variant.id);
                                              }
                                            }
                                            else{
                                                buttonText = default_addToCartText;
                                                addToCartLink(products[p].id,variant.id);
                                            }
                                        }
                                        else{
                                            buttonText = default_addToCartText;
                                            addToCartLink(products[p].id,variant.id);
                                        }

                                        var product_html;
                                        selected_pdt[products[p].id] = variant.id;
                                        variant_price = variant.price;

                                        var pdtPrice = variant_price;
                                        var var_products = products[p].variants;
                                        var var_images = products[p].images;
                                        var p_id = products[p].id;
                                        var added_pdt = false;
                                      
                                        if(product_sections!=undefined){
                                          for (const section in product_sections) {
                                            if (product_sections[section].includes(String(products[p].id))) {
                                              var product_section_grid = document.getElementById(section+"_product_grid");
                                              product_html = '<div><a id="url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="image_tangent_product_' + p + '" src="' + imgsrc + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p id="price_tangent_product_' + p + '" class="tangent_product_price_text">' + domainCurrency + pdtPrice + '</p></a><div id="tangent_product_' + p + '"></div><a class="tangent-product-add-btn-wrapper" id="'+selected_pdt[products[p].id]+'" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="'+section+'_cart_tangent_product_' + p + '_text">' + default_addToCartText + '</p></a><div/>';
                                              product_section_grid.innerHTML = product_section_grid.innerHTML + product_html;
                                            }  
                                          }
                                        }
                                    }
                                })
                            }
                        }
                    }
                  
                    addToCartCount = active_product_count;
                    // ENABLE EVENT LISTENER FOR ALL OPTIONS BUTTONS
                    var all_options = document.getElementsByClassName('tangent_option');
                    for (var o = 0; o < all_options.length; o++) {
                        all_options[o].addEventListener(
                            'click',
                            function () { changePdtVariant(this); },
                            false
                        );
                    }

                    // ENABLE EVENT LISTENER FOR ALL ADD TO CART BUTTON
                    var all_btns = document.getElementsByClassName('tangent-product-add-btn-wrapper');
                    for (var b = 0; b < all_btns.length; b++) {
                        all_btns[b].addEventListener(
                            'click',
                            function () { addToCart(this); },
                            false
                        );
                    }

                  
                }
                else {
                    document.getElementById('tangent-general-text').innerHTML = "No products found. Please retry!";
                    console.log("No products found Please retry");
                }

                if (jsonData.description != '') {
                    // document.getElementById('tangent-checkout-description').style.display = "block";
                    // document.getElementById('tangent-checkout-description').innerHTML = jsonData.description;
                }
                else {

                    document.getElementById('tangent-general-text').style.display = "block";
                    console.log("No descripton found");
                }
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", checkout_url, true);
    xmlhttp.send();

}

// Section Creation
function createProductSection(jsonData){
  var pdt_sections = jsonData.product_sections;
  var text_sections = jsonData.text_sections;
  
  for (const section_name in pdt_sections) {
    var section_layout = document.getElementById(section_name+"_container");
    var section_div = document.createElement("div");
    section_div.id = section_name;
    section_div.classList.add("section_product_container");
    section_div.classList.add(section_name+"_product_container");

    // Adding text sections before products
    if(text_sections!=undefined){
      createTextSectionForSection(text_sections,section_name);
    }    
    
    var product_grid_div = document.createElement("div");
    product_grid_div.id = section_name+"_product_grid";
    product_grid_div.classList.add("section_product_grid");
    product_grid_div.classList.add(section_name+"_product_grid");
    section_div.appendChild(product_grid_div);

    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");

    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.href="#";
    add_all_cart_link.innerHTML = "Add all to Cart";
    add_all_cart_link.addEventListener(
        'click',
        function () { addAllTocartFunction(section_name); },
        false
    );
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
    
    section_div.appendChild(add_all_to_cart_p_tag);
    
    section_layout.appendChild(section_div);
  }
}

function createTextSectionForSection(text_sections, section_name){
  if(text_sections[section_name]!=undefined){
    var section_layout = document.getElementById(section_name+"_container");
    if(section_layout!=undefined){
      var section_div = document.createElement("div");
      section_div.id = section_name+"_text_container";
      section_div.classList.add("section_text_container");
      section_div.classList.add(section_name+"_text_container");
      section_div.innerHTML = text_sections[section_name].join(' ');
      section_layout.appendChild(section_div);
    }
  }
}

function setActiveTab(){
  if (all_tags.includes('5_mins')) {
    document.getElementById("basics").classList.add("active");
    document.getElementById("section_basic_container").style.display="flex";
  }
  else if (all_tags.includes('10_mins')) {
    document.getElementById("essentials").classList.add("active");
    document.getElementById("section_essentials_container").style.display="flex";
  } 
  else {
    document.getElementById("works").classList.add("active");
    document.getElementById("section_works_container").style.display="flex";
  }
  document.getElementById("tab-wrapper").style.display="block";
}

function isProductAvailable(product, variant){
  let product_available = true;
  if (product.status != "active") {
    product_available = false;
  } else if (variant.inventory_policy == "deny" && variant.inventory_quantity < 1 && variant.inventory_management != null) {
    product_available = false;
  }
  return product_available;
}

function addToCartLink(pid,vid){
  if(product_sections!=undefined){
    for (const section in product_sections) {
      if (product_sections[section].includes(String(pid))) {
        switch(section) {
          case "section_basic":
            if (active_basics_count == 0) {
                addBasicsToCartLink += vid;
                basics_array.push(vid);
                active_basics_count++;
            } else {
                if(!basics_array.includes(vid)){
                  addBasicsToCartLink += "&id[]=" + vid;
                  basics_array.push(vid);
                  active_basics_count++;
                }
            }
            break;
          case "section_essentials":
            if (active_essential_count == 0) {
                addEssentialToCartLink += vid;
                essential_array.push(vid);
                active_essential_count++;
            } else {
              if(!essential_array.includes(vid)){
                addEssentialToCartLink += "&id[]=" + vid;
                essential_array.push(vid);
                active_essential_count++;
              }
            }
            
            break;
          case "section_works":
            if (active_works_count == 0) {
                addWorksToCartLink += vid;
                works_array.push(vid);
                active_works_count++;
            } else {
               if(!works_array.includes(vid)){
                addWorksToCartLink += "&id[]=" + vid;
                works_array.push(vid);
                active_works_count++;
               }
            }
            
            break;
          default:
            if (active_additional_count == 0) {
                addAdditionalToCartLink += vid;
                additional_array.push(vid);
                active_additional_count++;
            } else {
               if(!additional_array.includes(vid)){
                addAdditionalToCartLink += "&id[]=" + vid;
                additional_array.push(vid);
                active_additional_count++;
               }
            }
        }
      }                                
    }
  }
}

// Section Text Creation
function createTextSection(data){
  var text_sections = data.text_sections;
  var pdt_sections = data.product_sections;
  for (const section_name in text_sections) {
    if(pdt_sections[section_name]==undefined){
      var section_layout = document.getElementById(section_name+"_container");
      if(section_layout!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_layout.appendChild(section_div);
      }
    }
  }
}

function clickHandle(evt, eName) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Set the tab to be "active".
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(eName).style.display = "flex";
  
  evt.currentTarget.className += " active";
}

function addAllTocartFunction(section) {   
    if (active_works_count > 0) {
        switch(section) {
          case 'section_basic':
            document.getElementById(section+"_add_all_cart_link").setAttribute("href", addBasicsToCartLink);
            break;
          case 'section_essentials':
            document.getElementById(section+"_add_all_cart_link").setAttribute("href", addEssentialToCartLink);
            break;
          case 'section_works':
            document.getElementById(section+"_add_all_cart_link").setAttribute("href", addWorksToCartLink);
            break;
          default:
            document.getElementById(section+"_add_all_cart_link").setAttribute("href", addAdditionalToCartLink);
        }
    }
    else {
        var x = document.getElementById("message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

function changePdtVariant(ele) {
    var cartUrl = domainUrl + "/cart/add?id[]=";
    var eleId = ele.id;
    var arr = eleId.split(":");

    var productNumberText = arr[0];
    var optionNumberText = arr[1];
    var pStart = productNumberText.lastIndexOf('_');
    var oStart = optionNumberText.lastIndexOf('_');

    // Product and Option Number
    var pNo = productNumberText.substring(pStart + 1);
    var oNo = optionNumberText.substring(oStart + 1);

    //Product ID
    var pId = parseInt(pNo);
    var v = productNumberText.lastIndexOf('_product');
    var section = productNumberText.substring(0,v);
  
    // Product Details
    var pdt = products[pId];
    
    var element = document.getElementById(selected_pdt[pdt.id]);
    if(element!=undefined){
      element.childNodes[0].classList.remove("added-to-cart-style");
      element.childNodes[0].innerHTML = "Add to cart";      
    }
    var variant_price = domainCurrency;

    // Product Variants
    var product_variants = pdt.variants;

    // Variant Option Values
    var opt1_value;
    var opt2_value;
    var opt3_value;

    // Getting current variant option selections
    if (product_variants.length > 0) {
        for (var pv = 0; pv < product_variants.length; pv++) {
            if (product_variants[pv].id == selected_pdt[pdt.id]) {
                prev_variant = product_variants[pv];
                opt1_value = product_variants[pv].option1;
                opt2_value = product_variants[pv].option2;
                opt3_value = product_variants[pv].option3;
            }
        }
    }

    var opt1_list;
    // Identify and Highlight new selection if it is on Option 1 list of Product
    if (ele.classList.contains("tangent_options_1")) {
        opt1_list = document.getElementsByClassName(section+"_product_" + pId);
        
        if (opt1_list.length > 0) {
            for (var op1 = 0; op1 < opt1_list.length; op1++) {
                if (op1 == oNo) {
                    opt1_list[op1].classList.add("tangent_selected-variant");
                    opt1_value = opt1_list[op1].innerHTML;
                }
                else {
                    opt1_list[op1].classList.remove("tangent_selected-variant");
                }
            }
        }
    }

    var opt2_list;
    // Identify and Highlight new selection if it is on Option 2 list of Product
    if (ele.classList.contains("tangent_options_2")) {
        opt2_list = document.getElementsByClassName(section+"_product_" + pId);
        if (opt2_list.length > 0) {
            for (var op2 = 0; op2 < opt2_list.length; op2++) {
                if (op2 == oNo) {
                    opt2_list[op2].classList.add("tangent_selected-variant");
                    opt2_value = opt2_list[op2].innerHTML;
                }
                else {
                    opt2_list[op2].classList.remove("tangent_selected-variant");
                }
            }
        }
    }

    var opt3_list;
    // Identify and Highlight new selection if it is on Option 3 list of Product
    if (ele.classList.contains("tangent_options_3")) {
        opt3_list = document.getElementsByClassName(section+"_product_" + pId);
        if (opt3_list.length > 0) {
            for (var op3 = 0; op3 < opt3_list.length; op3++) {
                if (op3 == oNo) {
                    opt3_list[op3].classList.add("tangent_selected-variant");
                    opt3_value = opt3_list[op3].innerHTML;
                }
                else {
                    opt3_list[op3].classList.remove("tangent_selected-variant");
                }
            }
        }
    }

    var option_variant_key;
    // Joining the options found and matching with options to variant mapping to get variant id
    if (opt1_value != null) {
        option_variant_key = opt1_value;
    }
    if (opt2_value != null) {
        option_variant_key = option_variant_key + "_" + opt2_value;
    }
    if (opt3_value != null) {
        option_variant_key = option_variant_key + "_" + opt3_value;
    }

    // Fetching and setting new variant id to selected product-id in product-variant map object
    if (option2_variant_map[pdt.id] != undefined) {
        if (option2_variant_map[pdt.id][option_variant_key] != undefined) {
            selected_pdt[pdt.id] = option2_variant_map[pdt.id][option_variant_key].id + "";
        }
    }

    var add_current_pdt = true;
    var cart_btn = element;
    var cart_btn_text = cart_btn.childNodes[0]; //document.getElementById("cart_tangent_product_" + pId + "_text");

  
    // Check if product is active and if not disable add to cart button
    if (pdt.status == "active") {
        if(cart_btn!=undefined){
          cart_btn.classList.remove("disable-btn-wrapper");

          // Choose variant object from variant list in product object using variant id mapped to product id in product-variant mapping object
          var variant_select;
          if (product_variants.length > 0) {
              for (var pv = 0; pv < product_variants.length; pv++) {
                  if (product_variants[pv].id == selected_pdt[pdt.id]) {
                      variant_select = product_variants[pv];
                  }
              }
          }

          if (variant_select != undefined) {
            if(variant_select.inventory_policy == "deny"){
                if(variant_select.inventory_quantity<1){
                    if(variant_select.inventory_management!=null){
                        add_current_pdt = false;
                        cart_btn_text.innerHTML = outOfStock;
                        cart_btn.classList.add("disable-btn-wrapper");
                    }
                    else{
                        selected_pdt[pdt.id] = variant_select.id;
                        var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                        cart_btn.classList.remove("disable-btn-wrapper");
                        cart_btn_text.innerHTML = default_addToCartText;

                        cart_btn.id = selected_pdt[pdt.id];
                    } 
                }
                else{
                    selected_pdt[pdt.id] = variant_select.id;
                    var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                    cart_btn.classList.remove("disable-btn-wrapper");
                    cart_btn_text.innerHTML = default_addToCartText;

                    cart_btn.id = selected_pdt[pdt.id];
                }
            }
            else{
                selected_pdt[pdt.id] = variant_select.id;
                var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                cart_btn.classList.remove("disable-btn-wrapper");
                cart_btn_text.innerHTML = default_addToCartText;

                cart_btn.id = selected_pdt[pdt.id];
            }
          }
        }
    }
    else {
        add_current_pdt = false;
        cart_btn_text.innerHTML = outOfStock;
        cart_btn.classList.add("disable-btn-wrapper");
    }

    var sp = 0;
    // Loop through product list and update cart url for add all to cart
    for (var p = 0; p < products.length; p++) {
        var product_variants = products[p].variants;

        // Check if product status , if not skip adding to cart-url
        if (products[p].status == "active") {
            // If looping product and selection product same
            if (products[p].id == pdt.id) {
                if (add_current_pdt) {
                    if (sp == 0) {
                        cartUrl = cartUrl + selected_pdt[pdt.id];
                    }
                    else {
                        cartUrl = cartUrl + '&id[]=' + selected_pdt[pdt.id];
                    }
                    sp = sp + 1;
                }
            }
            else {

                // Loop through variants of looping product and find matched variant from selected product-variant mapping object
                for (var pv = 0; pv < product_variants.length; pv++) {
                    if (selected_pdt[products[p].id] == product_variants[pv].id) {
                        var variant_select = product_variants[pv].id;
                        if(variant_select.inventory_policy == "deny"){
                            if(variant_select.inventory_quantity<1){
                              if(variant_select.inventory_management==null){
                                  if (sp == 0) {
                                  cartUrl = cartUrl + product_variants[pv].id;
                                  }
                                  else {
                                      cartUrl = cartUrl + '&id[]=' + product_variants[pv].id;
                                  }
                                  sp = sp + 1;
                              } 
                            }
                            else{
                                if (sp == 0) {
                                  cartUrl = cartUrl + product_variants[pv].id;
                                }
                                else {
                                  cartUrl = cartUrl + '&id[]=' + product_variants[pv].id;
                                }
                                sp = sp + 1;
                            }
                        }
                        else{
                            if (sp == 0) {
                                cartUrl = cartUrl + product_variants[pv].id;
                            }
                            else {
                                cartUrl = cartUrl + '&id[]=' + product_variants[pv].id;
                            }
                            sp = sp + 1;
                        }
                    }
                }
            }
        }
        variant_product_url = domainUrl + '/products/';
        // To Set Variant Price dynamically 
        if (products[p].id == pdt.id) {
            var variant_pdt_matched = false;
            for (var pv = 0; pv < product_variants.length; pv++) {
                if (selected_pdt[products[p].id] == product_variants[pv].id) {
                    variant_pdt_matched = true;
                    variant_price = variant_price + product_variants[pv].price;
                    variant_product_url = variant_product_url + pdt.handle + "?variant=" + product_variants[pv].id;
                    
                    variant_image = getVariantImage(product_variants[pv].image_id, products[p]);
                }
            }
            if (!variant_pdt_matched) {
                variant_price = variant_price + product_variants[0].price;
                variant_product_url = variant_product_url + pdt.handle + "?variant=" + product_variants[0].id;
            }
            document.getElementById("url_tangent_product_" + pId).href = variant_product_url;
        }
    }
    document.getElementById("price_tangent_product_" + pId).innerHTML = variant_price;

    // Change of image based on variant
    if(variant_image!=undefined){
        document.getElementById("image_tangent_product_" + pId).src = variant_image;
    }
  
    addToCartCount = sp;
    addAllToCartLink = cartUrl;
}

const isSelectedVariantPresent = (selectedVariants, productId) => {
    for (let key in selectedVariants) {
        if (key == productId) {
            if (selectedVariants[key] == null) {
                return [];
            }
            else if (typeof selectedVariants[key] == "string") {
                return selectedVariants[key].split();
            }
            else {
                return selectedVariants[key];
            }
        }
    }
}

const getVariantImage = (imageId, product) => {
    var pdtImg;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    pdtImg = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            pdtImg = product.image.src;
        }
        else{
            pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(pdtImg== undefined || pdtImg==null){
        pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return pdtImg;
}

function addToCart(btn){ 
    var data = {
        "id": btn.id,
        "quantity": 1
    };
    
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() { 
          
            if(btn!=undefined){
              btn.childNodes[0].innerHTML = "Added to Cart!";
              btn.childNodes[0].classList.add("added-to-cart-style");
            }
            
            document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
            document.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            })); 

            
        }, 
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log("Error on adding to cart",textStatus);
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    });
    
}